export default function PersonalizedVideo(): void {
  const videoWrappers = document.querySelectorAll<HTMLDivElement>("[data-video-wrapper]");
  if (!videoWrappers.length) return;
  videoWrappers.forEach((wrapper) => {
    const playBtn = wrapper.querySelector<HTMLButtonElement>(".js-play-btn");
    const ctaBtn = wrapper.querySelector<HTMLElement>(".js-video-cta");
    const isVidyard = wrapper.hasAttribute("data-vidyard");
    if (isVidyard) {
      const iframe = wrapper.querySelector<HTMLIFrameElement>(".vidyard-iframe");
      if (!iframe) return;
      const playVidyard = () => {
        const url = new URL(iframe.src);
        url.searchParams.set("autoplay", "1");

        const poster = wrapper.querySelector<HTMLImageElement>("img");
        const overlay = wrapper.querySelector<HTMLElement>(".js-play-overlay");
        if (poster) poster.style.display = "none";
        if (overlay) overlay.style.display = "none";
        iframe.src = url.toString();
        iframe.style.display = "block";
      };
      if (playBtn) playBtn.addEventListener("click", playVidyard);
      if (ctaBtn) {
        ctaBtn.addEventListener("click", (e: MouseEvent) => {
          e.preventDefault();
          iframe.scrollIntoView({ behavior: "smooth", block: "center" });
          playVidyard();
        });
      }
    } else {
      const video = wrapper.querySelector<HTMLVideoElement>("video");
      if (!video) return;
      if (playBtn) {
        playBtn.addEventListener("click", () => video.play());
        video.addEventListener("click", () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
        video.addEventListener("play", () => {
          playBtn.style.display = "none";
        });
        video.addEventListener("pause", () => {
          if (!video.ended) playBtn.style.display = "flex";
        });
        video.addEventListener("ended", () => {
          playBtn.style.display = "flex";
        });
      }
      if (ctaBtn) {
        ctaBtn.addEventListener("click", (e: MouseEvent) => {
          e.preventDefault();
          video.scrollIntoView({ behavior: "smooth", block: "center" });
          video.play();
        });
      }
    }
  });
}
